// extracted by mini-css-extract-plugin
export default {"WarningMessage":"TotalExpenseWarning_WarningMessage__3iY+P"};